export const LPOA_DOCUMENT_MODAL = 'LPOA_DOCUMENT_MODAL';
export const LPOA_DOCUMENT_FORM = 'LPOA_DOCUMENT_FORM';
